import styled from "styled-components";

import { colorsPalettes, rgba } from "@similarweb/styles";
import { NoBorderButton, TextWrapper } from "@similarweb/ui-components";

export const AdvancedFilterButton = styled(NoBorderButton)`
    background-color: ${rgba(colorsPalettes.carbon[200], 0.2)};
    border-radius: 40px;
    padding: 4px 12px;
    height: 32px;
    box-sizing: border-box;
    ${TextWrapper} {
        display: flex;
        align-items: center;
    }
    &:hover {
        background-color: ${rgba(colorsPalettes.carbon[500], 0.1)};
    }
`;
